import { __assign } from "tslib";
import { EVENTS_WEB_API_BASE } from './endpoints';
var EventsHttpClient = /** @class */ (function () {
    function EventsHttpClient(controllerParams, baseUrl, linguisticHeader) {
        var _this = this;
        if (baseUrl === void 0) { baseUrl = EVENTS_WEB_API_BASE; }
        this.controllerParams = controllerParams;
        this.baseUrl = baseUrl;
        this.linguisticHeader = linguisticHeader;
        this.getHeaders = function (requestOptions) {
            if (requestOptions === void 0) { requestOptions = {}; }
            return __assign(__assign({}, requestOptions), { headers: __assign(__assign({}, requestOptions.headers), { 'x-wix-linguist': _this.linguisticHeader }) });
        };
        this.httpClient = this.controllerParams.flowAPI.httpClient;
    }
    EventsHttpClient.prototype.get = function (url, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return this.httpClient
            .get("" + this.baseUrl + url, this.getHeaders(requestOptions))
            .then(function (response) { return response.data; })
            .catch(function (error) {
            if (error.response) {
                throw { payload: error.response.data };
            }
        });
    };
    EventsHttpClient.prototype.delete = function (url, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return this.httpClient
            .delete("" + this.baseUrl + url, this.getHeaders(requestOptions))
            .then(function (response) { return response.data; })
            .catch(function (error) {
            if (error.response) {
                throw { payload: error.response.data };
            }
        });
    };
    EventsHttpClient.prototype.put = function (url, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return this.httpClient
            .put("" + this.baseUrl + url, this.getHeaders(requestOptions))
            .then(function (response) { return response.data; })
            .catch(function (error) {
            if (error.response) {
                throw { payload: error.response.data };
            }
        });
    };
    EventsHttpClient.prototype.post = function (url, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return this.httpClient
            .post("" + this.baseUrl + url, this.getHeaders(requestOptions))
            .then(function (response) { return response.data; })
            .catch(function (error) {
            if (error.response) {
                throw { payload: error.response.data };
            }
        });
    };
    EventsHttpClient.prototype.patch = function (url, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return this.httpClient
            .patch("" + this.baseUrl + url, this.getHeaders(requestOptions))
            .then(function (response) { return response.data; })
            .catch(function (error) {
            if (error.response) {
                throw { payload: error.response.data };
            }
        });
    };
    return EventsHttpClient;
}());
export { EventsHttpClient };
//# sourceMappingURL=http-client.js.map